module.exports = __webpack_public_path__ + "media/images/piscine extérieure-fa3629cab2890cc0656d18278233ba84.svg";